import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-week-selector-dialog',
  templateUrl: './week-selector-dialog.component.html',
  styleUrls: ['./week-selector-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class WeekSelectorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<WeekSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedWeeks: number[]
      singleSelection: boolean
      includeFuture?: boolean
    }
  ) {}
}
